<template>
    <div>
        <div
                :style="{backgroundImage: getStringUrlImage()}"
                class="banniere-collection"
        >
            <h1 class="h1">{{ collection.title }}</h1>
        </div>

        <div class="collection-container">
            <div class="collection-content" v-html="getContent1()"></div>

            <div v-if="getCategory()">
                <Category
                        :category="getCategory()"
                ></Category>
            </div>

            <div v-if="hasCategories()" class="o-full container-collection-categories">
                <div class="block-collection-categories">
                    <h2 class="products-section-title"><span>Choisissez votre type de sac</span></h2>
                    <div class="listing-categories">
                        <CategoryMini v-for="(item) in getCategories()"
                                      :key="item.id"
                                      :category="item"
                        >
                        </CategoryMini>
                        <Product v-for="(item, index) in getProducts()"
                                 v-if="index < getNbProductsDiplay()"
                                 :key="item.id"
                                 :product="item"
                        ></Product>
                    </div>
                </div>
            </div>

            <div class="collection-content" v-html="getContent2()"></div>

            <div class="bestsellers" v-if="hasBestsellers()">
                <section class="featured-products clearfix">
                    <h2 class="products-section-title">
                        <span>
                              Produits populaires
                        </span>
                    </h2>
                    <div class="products">
                        <Bestseller v-for="(item, index) in getBestsellers()"
                                    v-if="index < getNbProductsDiplay()"
                                    :key="item.id"
                                    :bestseller="item"
                        ></Bestseller>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>


<script>

    import {mapGetters, mapActions} from 'vuex'
    import Category from "./Category";
    import Product from "./Product";
    import Bestseller from "./Bestseller";
    import CategoryMini from "./CategoryMini";
    import * as types from '../store/types';
    import "../style/Collection.scss";

    export default {
        name: 'Collection',
        components: {
            Category,
            Product,
            Bestseller,
            CategoryMini
        },
        props: {
            id: Number,
            collection: Object
        },
        created() {
            this.loadData({
                collection: this.collection
            });
        },
        methods: {
            hasProduct() {
                return !!this.getProducts();
            },
            hasBestsellers() {
                return !!this.getBestsellers();
            },
            hasCategories() {
                return this.getCategories().length > 0;
            },
            getStringUrlImage() {
                return "url(" + this.collection.image + ")";
            },
            ...mapActions({
                loadData: types.LOAD_DATA_COLLECTION
            }),
            ...mapGetters({
                getCollection: types.GET_COLLECTION,
                getContent1: types.GET_CONTENT1,
                getContent2: types.GET_CONTENT2,
                getProducts: types.GET_PRODUCTS_RESULT,
                getBestsellers: types.GET_BESTSELLERS_RESULT,
                getIdCategory: types.GET_ID_CATEGORY,
                getCategory: types.GET_CATEGORY,
                getCategories: types.GET_CATEGORIES,
                getNbProductsDiplay: types.GET_NB_PRODUCTS_DISPLAY,
            })

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Collection.vue